import React, { useState, useEffect } from 'react';
import "./../../../../css/payment-print.css"
import apf_logo from '../../../../images/apf_small_logo.png';
import { Link } from "react-router-dom";
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLocation } from 'react-router-dom';



const PaymentOnline = () => {
  const BaseUrl = process.env.REACT_APP_API_BASE_URL;
  const [searchParams] = useSearchParams();

  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [isPaymentVerified, setIsPaymentVerified] = useState(false);
  const location = useLocation();
  const [orderData, setOrderData] = useState(null);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const encodedData = queryParams.get('data');

    if (encodedData) {
      try {
        const decoded = atob(decodeURIComponent(encodedData));
        const parsed = JSON.parse(decoded);
        console.log('paresed', parsed);
        setOrderData(parsed);
      } catch (err) {
        console.error('Error decoding data:', err);
      }
    }
  }, [location.search]);

    const orderId = orderData?.order_id;
    const totalAmount = orderData?.amount;

  

  useEffect(() => {
    if (!orderId) {
      setLoading(false);
      return;
    }

    fetch(`${BaseUrl}/manage_order/getPayment/${orderId}?total_amount=${totalAmount}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setOrderDetails(data.data);
          console.log(data.data);
        } else {
          setOrderDetails(null);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching order:', err);
        setOrderDetails(null);
        setLoading(false);
      });
  }, [orderId, totalAmount, BaseUrl]);

    useEffect(() => {
      if (orderDetails && orderDetails.payment_id) {
        const paidFlag = localStorage.getItem('paymentVerified_' + orderDetails.payment_id);
        if (paidFlag === 'true') {
          setIsPaymentVerified(true);
        }
      }
    }, [orderDetails]);

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

const handlePayment = async () => {
    const res = await loadRazorpayScript();
    if (!res) {
        alert("Razorpay SDK failed to load. Check your internet.");
        return;
    }

    // Correct API call here:
    const response = await fetch(`${BaseUrl}/razor_pay/create_order`, {
        method: "POST",
        headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        },
        body: JSON.stringify({
        total_amount: totalAmount,
        payment_id: orderDetails.payment_id,
        }),
    });

    const razorpayOrder = await response.json();
    const user_id = parseInt(localStorage.getItem("user_id"), 10);

    if (!razorpayOrder.success) {
        alert("Something went wrong while initiating payment.");
        return;
    }
    const options = {
    key: "rzp_test_cjiZ7kyueJCUGb",
    amount: razorpayOrder.order.amount,
    currency: razorpayOrder.order.currency,
    name: "APF",
    description: "Order Payment",
    image: apf_logo,
    order_id: razorpayOrder.order.id,
    handler: function (response) {

        fetch(`${BaseUrl}/razor_pay/verify-payment`, {  
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            payment_id : orderDetails.payment_id,
            razorpay_payment_id: response.razorpay_payment_id,
            payment_type : orderDetails.payment_type,
            razorpay_order_id: response.razorpay_order_id,
            razorpay_signature: response.razorpay_signature,
            user_id: user_id,
        }),
        })
        .then(res => res.json())
        .then(data => {
        if(data.success) {
            toast.success("Payment verified successfully!");
            setIsPaymentVerified(true);
            localStorage.setItem('paymentVerified_' + orderDetails.payment_id, 'true');
        } else {
            toast.error("Payment verification failed.");
        }
        })
        .catch(err => {
        console.error("Verification error:", err);
        toast.error("Error verifying payment.");
        });
    },
    prefill: {
        name: orderDetails.customer_name,
        email: orderDetails.email || " ",
        contact: orderDetails.customer_number,
    },
    theme: {
        color: "#025D3A",
    },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
    }



  if (loading) {
    return <div>Loading order details...</div>;
  }

  if (!orderDetails) {
    return <div>Payment not found or amount mismatch.</div>;
  }

  return (
    <div>
      <div className='pay-page_print'>
        <div className='bg-primary py-2 px-2 header-print'>
          <div>
            <label className="justify-content-start p-0 ms-1">
              <img src={apf_logo} alt="Logo" className="w-100px h-100px ms-0" />
            </label>
          </div>
          <div>
            <div>
              <div className='fs-2 text-white text-center mb-4 fw-semibold'>
                <label>Online Payment</label>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile View */}
        <div className="row card details-card mobile_view">
          <div className='mb-2 text-center'>
            <div className='text-danger text-center font-w600 mt-2 mb-2 fs-4'>Payment Amount</div>
            <div className='amount-card text-center fs-2'>₹ {orderDetails.amount} /-</div>
          </div>
          <div className='row mt-4'>
            <div className='col-lg-12 mb-1 row_div_details'>
              <label className='print-label'>Customer Name</label>
              <label className='print-label'>{orderDetails.customer_name}</label>
            </div>
            <div className='col-lg-12 mb-1 row_div_details'>
              <label className='print-label'>Mobile No</label>
              <label className='print-label'>{orderDetails.customer_number}</label>
            </div>
            <div className='col-lg-12 mb-1 row_div_details'>
              <label className='print-label'>Order Id</label>
              <label className='print-label'>{orderDetails.catering_id}</label>
            </div>
            <div className='col-lg-12 mb-1 row_div_details'>
              <label className='print-label'>Pay Date</label>
              <label className='print-label'>{formatDate(new Date())}</label>
            </div>
            <div className='col-lg-12 mb-1 row_div_details'>
              <label className='print-label'>Pay Amount</label>
              <label className='print-label-amount'>₹ {orderDetails.amount}</label>
            </div>
            {orderDetails.gst_amount !== 0 && (
              <div className='col-lg-12 mb-1 row_div_details'>
                <label className='print-label'>GST Amount</label>
                <label className='print-label-amount'>₹ {orderDetails.gst_amount}</label>
              </div>
            )}
            <div className='col-lg-12 mb-1 row_div_details'>
              <label className='print-label'>Grand Total</label>
              <label className='print-label-amount' style={{ fontSize: '14px' }}>₹ {orderDetails.amount}</label>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4 no-print">
             {isPaymentVerified ? (
                  <button
                    className="btn btn-sm text-white bg-primary"
                    style={{cursor: "not-allowed" }}
                  >
                    Paid
                  </button>
                ) : (
                  <Link
                    to="#"
                    className="btn btn-sm btn-primary"
                    onClick={(e) => {
                      e.preventDefault();
                      handlePayment();
                    }}
                  >
                    Pay Now
                  </Link>
                )}
          </div>
        </div>

        {/* Desktop View */}
        <div className="card details-card desktop_view">
          <div className="row px-4 py-4">
            <div className="col-lg-6">
              <div className="mb-1 row_div_details">
                <label className="print-label-dk">Customer Name</label>
                <label className="print-label-dk">{orderDetails.customer_name}</label>
              </div>
              <div className="mb-1 row_div_details">
                <label className="print-label-dk">Mobile No</label>
                <label className="print-label-dk">{orderDetails.customer_number}</label>
              </div>
              <div className="mb-1 row_div_details">
                <label className="print-label-dk">Order Id</label>
                <label className="print-label-dk">{orderDetails.catering_id}</label>
              </div>
              <div className="mb-1 row_div_details">
                <label className="print-label-dk">Pay Date</label>
                <label className='print-label-dk'>{formatDate(new Date())}</label>
              </div>
              <div className="mb-1 row_div_details">
                <label className="print-label-dk">Pay Amount</label>
                <label className="print-label-dk-amount">₹ {totalAmount}</label>
              </div>
              <div className="mb-1 row_div_details">
                <label className="print-label-dk">Grand Total</label>
                <label className="print-label-dk-amount" style={{ fontSize: "1.4rem" }}>
                  ₹ {totalAmount}
                </label>
              </div>
            </div>
            <div className="col-lg-6 py-2 px-2 rounded" style={{ backgroundColor: "#c5f5cf7d" }}>
              <div className="mb-2 text-center">
                <div className="text-danger text-center font-w600 mt-2 mb-2 fs-4" style={{ fontWeight: 700, fontSize: '1.75rem', color: '#EA1D25' }}>
                  Payment Amount
                </div>
                <div className="amount-card text-center fs-2">₹ {totalAmount} /-</div>
              </div>  
              <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4 no-print">
                {isPaymentVerified ? (
                  <button
                    className="btn btn-sm text-white bg-primary"
                    style={{cursor: "not-allowed" }}
                  >
                    Paid
                  </button>
                ) : (
                  <Link
                    to="#"
                    className="btn btn-sm btn-primary"
                    onClick={(e) => {
                      e.preventDefault();
                      handlePayment();
                    }}
                  >
                    Pay Now
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}

export default PaymentOnline;
